import styled from 'styled-components';
import { tokens } from '../../components/modal-form/tokens';

const Chapa = styled.div`
    display: inline-flex;
    flex-direction: column;
    width: 118px;
    border: 1.5px solid #343a40;
    border-radius: ${tokens.radiusSm};
    overflow: hidden;
    background: #ffffff;

    .faixa {
        background: #1F467E;
        color: #ffffff;
        font-size: 7px;
        font-weight: 600;
        letter-spacing: 0.2em;
        text-align: center;
        padding: 1px 0;
    }

    .numero {
        font-family: 'Consolas', 'Menlo', 'Courier New', monospace;
        font-weight: 600;
        font-size: 17px;
        letter-spacing: 0.05em;
        text-align: center;
        color: #212529;
        padding: 1px 0 2px;
    }
`;

export default function Placa({ placa }: { placa: string }) {
    const formatada = placa?.length === 7 ? `${placa.slice(0, 3)} ${placa.slice(3)}` : placa;
    return (
        <Chapa aria-label={`Placa ${placa}`}>
            <div className="faixa">BRASIL</div>
            <div className="numero">{formatada}</div>
        </Chapa>
    );
}
